import Datos from './Datos';

export default Datos;
